import { IRadioGroupItem } from "@pjs/core-ui";
import { userUiI18n } from "../../i18n/UserUiI18n.const";

export const pageSavingRadioGroupItems: Array<IRadioGroupItem> = [
    {
        id: "page-saving-false",
        value: "false",
        get label() {
            return userUiI18n.getString("assessment.page_saving.false");
        }
    },
    {
        id: "page-saving-true",
        value: "true",
        get label() {
            return userUiI18n.getString("assessment.page_saving.true");
        }
    }
];
